
import './App.css';
import { Calculator } from './components/Calculator';
import { Footer } from './components/Footer'

function App() {
  return (
    <div className="App">
      <Calculator />
      <Footer />
    </div>
  );
}

export default App;
